import React__default from 'react';
import classNames from 'classnames';

const ProductCompareTile = (props) => {
    const { className, image, price, title, productUrl, productAttributes, viewProductBtnText } = props;
    const classes = classNames('xps-pct', className);
    const isExternalHref = /^https?:\/\//i.test(productUrl || '');
    return (React__default.createElement("div", { className: classes },
        React__default.createElement("div", { className: 'xps-pct--product-summary' },
            React__default.createElement("a", { href: productUrl, target: isExternalHref ? '_blank' : '_self' },
                React__default.createElement("img", { src: image, alt: title })),
            React__default.createElement("div", { className: 'xps-pct--product-summary-price' }, price),
            React__default.createElement("a", { href: productUrl, target: isExternalHref ? '_blank' : '_self' },
                React__default.createElement("div", { className: 'xps-pct--product-summary-title' }, title)),
            React__default.createElement("a", { href: productUrl, target: isExternalHref ? '_blank' : '_self', className: 'xps-pct--product-summary-view' },
                React__default.createElement("button", { type: 'button', className: 'xps-pct--product-summary-view-btn' }, viewProductBtnText || 'View product'))),
        React__default.createElement("div", { className: 'xps-pct--product-specification' }, productAttributes &&
            productAttributes.map((item, index) => React__default.createElement("div", { className: classNames('xps-pct--product-specification-item', { 'xps-pct--with-icons': item.icon }), key: index },
                item.icon && item.description &&
                    React__default.createElement("img", { src: item.icon, alt: item.name || 'specification-item' }),
                React__default.createElement("div", { className: 'xps-pct--specification-content' },
                    item.name &&
                        React__default.createElement("div", { className: 'xps-pct--specification-content-name' }, item.name),
                    React__default.createElement("div", { className: 'xps-pct--specification-content-description', dangerouslySetInnerHTML: { __html: item.description } })))))));
};

export { ProductCompareTile };
//# sourceMappingURL=ProductCompareTile.js.map
